import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Check } from 'lucide-react';
export function Guarantee() {
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-cream-dark/30 relative overflow-hidden" data-id="element-126">
      <div className="dashed-divider absolute top-0 left-0" data-id="element-127" />

      {/* Decorative blobs */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-caramel-light/20 rounded-full blur-3xl pointer-events-none" data-id="element-128" />
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-rose-light/20 rounded-full blur-3xl pointer-events-none" data-id="element-129" />

      <div className="max-w-4xl mx-auto relative" data-id="element-130">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.7
      }} className="bg-white rounded-[2.5rem] shadow-2xl p-8 md:p-12 border-2 border-caramel/20 relative overflow-hidden" data-id="element-131">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-center" data-id="element-132">
            {/* Shield Badge */}
            <div className="flex justify-center md:col-span-1" data-id="element-133">
              <motion.div animate={{
              scale: [1, 1.05, 1]
            }} transition={{
              repeat: Infinity,
              duration: 3,
              ease: 'easeInOut'
            }} className="relative" data-id="element-134">
                {/* Outer glow */}
                <div className="absolute inset-0 bg-caramel/30 rounded-full blur-2xl scale-110" data-id="element-135" />

                {/* Shield */}
                <div className="relative w-40 h-40 md:w-48 md:h-48 rounded-full bg-gradient-to-br from-caramel to-caramel-dark flex items-center justify-center shadow-glow border-4 border-white" data-id="element-136">
                  <div className="text-center text-white" data-id="element-137">
                    <ShieldCheck className="w-12 h-12 mx-auto mb-1" strokeWidth={2.5} data-id="element-138" />
                    <div className="font-serif font-bold text-3xl md:text-4xl leading-none" data-id="element-139">
                      7
                    </div>
                    <div className="text-[10px] md:text-xs font-bold uppercase tracking-widest mt-1" data-id="element-140">
                      Días de
                    </div>
                    <div className="text-[10px] md:text-xs font-bold uppercase tracking-widest" data-id="element-141">
                      Garantía
                    </div>
                  </div>
                </div>

                {/* Ribbon */}
                <div className="absolute -bottom-3 left-1/2 -translate-x-1/2 bg-espresso text-white text-[10px] md:text-xs font-bold px-4 py-1.5 rounded-full whitespace-nowrap shadow-lg uppercase tracking-wider" data-id="element-142">
                  100% Sin Riesgo
                </div>
              </motion.div>
            </div>

            {/* Text */}
            <div className="md:col-span-2 text-center md:text-left" data-id="element-143">
              <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-green-100 text-green-700 font-medium text-xs mb-4 border border-green-200" data-id="element-144">
                <ShieldCheck className="w-3.5 h-3.5" data-id="element-145" />
                COMPRA PROTEGIDA
              </div>

              <h2 className="text-3xl md:text-4xl font-serif font-bold text-espresso leading-tight mb-4" data-id="element-146">
                Garantía de Satisfacción de 7 Días
              </h2>

              <p className="text-espresso-light leading-relaxed mb-5 text-base md:text-lg" data-id="element-147">
                Si dentro de los próximos{' '}
                <strong className="text-espresso" data-id="element-148">7 días</strong> sientes que el
                manual no es para ti, escríbenos y te devolvemos el{' '}
                <strong className="text-espresso" data-id="element-149">100% de tu dinero</strong>.
                Sin preguntas. Sin trámites complicados.
              </p>

              <div className="space-y-2.5" data-id="element-150">
                {['Cero riesgo para ti', 'Reembolso completo en 24 horas', 'Te quedas con todo lo aprendido'].map((item, i) => <div key={i} className="flex items-center gap-2 justify-center md:justify-start" data-id="element-151">
                    <div className="w-5 h-5 rounded-full bg-green-100 flex items-center justify-center shrink-0" data-id="element-152">
                      <Check className="w-3 h-3 text-green-700" strokeWidth={3} data-id="element-153" />
                    </div>
                    <span className="text-espresso font-medium text-sm md:text-base" data-id="element-154">
                      {item}
                    </span>
                  </div>)}
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}